import isObject from "lodash/isObject";

export function objectToUrlSearchParam(obj) {
  if (!obj || !isObject(obj)) {
    return null;
  }

  const searchParams = new URLSearchParams();
  Object.keys(obj).forEach(k => searchParams.append(k, obj[k]));

  return searchParams;
}

export function objectToQueryString(obj) {
  const searchParams = objectToUrlSearchParam(obj);
  return searchParams?.toString() ?? "";
}
